import { h } from 'preact';
import { getStudioConfig } from 'utils/studioConfig';
import { getStyleVariable } from 'utils/thundr';

import MovieEditor from 'components/editor/movies/movieEditor';
import MoviePageHeader from 'components/editor/movies/movieHeader';
import HomeEditor from 'components/editor/movies/home';
import SynopsisEditor from 'components/editor/movies/synopsis';
import GalleryEditor from 'components/editor/movies/gallery';
import VideosEditor from 'components/editor/movies/videos';
import MoviePageFooter from 'components/editor/movies/movieFooter';

import s from 'components/editor/movies/landing/landing.sss';

const sectionComponents = {
	synopsis: SynopsisEditor,
	gallery: GalleryEditor,
	videos: VideosEditor,
};

export default class LandingPageEditor extends MovieEditor {
	s = s;

	getLandingPageSections() {
		const config = getStudioConfig();
		return config.homeSections;
	}

	renderHeader() {
		return (
			<MoviePageHeader {...this.props} />
		);
	}

	renderHomeHero() {
		return (
			<div class={this.s.heroContainer}>
				<HomeEditor {...this.props} />
			</div>
		);
	}

	renderSections() {
		const sections = this.getLandingPageSections();
		return sections.map((section) => {
			const Component = sectionComponents[section];
			return <Component {...this.props} />;
		});
	}

	renderFooter() {
		return (
			<MoviePageFooter
				{...this.props}
				class={this.s.footer}
				logos={this.movie?.footer?.logos}
				links={this.movie?.footer?.links}
				legalText={this.movie?.footer?.legalText}
			/>
		);
	}

	renderVisual() {
		const stylingValues = {
			'--movie-primary-color': getStyleVariable(this.state.thundrData, `primaryColor`),
		};
		const style = Object.entries(stylingValues).map(([k, v]) => v && `${k}:${v}`).filter(Boolean).join(';');

		return (
			<div class={this.s.visual} style={style}>
				{this.renderHeader()}
				{this.renderHomeHero()}
				{this.renderSections()}
				{this.renderFooter()}
			</div>
		);
	}

	renderSettings() {
		const activeElement = this.props.activeElement;

		if (activeElement.startsWith('/header')) {
			return <MoviePageHeader {...this.props} />;
		}

		if (activeElement === '/' || activeElement.startsWith('/pages/home')) {
			return <HomeEditor {...this.props} />;
		}

		if (activeElement.startsWith('/pages/synopsis')) {
			return <SynopsisEditor {...this.props} />;
		}

		if (activeElement.startsWith('/pages/gallery')) {
			return <GalleryEditor {...this.props} />;
		}

		if (activeElement.startsWith('/pages/videos')) {
			return <VideosEditor {...this.props} />;
		}

		if (activeElement.startsWith('/footer')) {
			return <MoviePageFooter {...this.props} />;
		}
	}
}